import { defineStore } from 'pinia'
import type { SurfaceCollectionCategoryWithCollections } from '~/types/api'

export const useSurfaces = defineStore('surfaces', () => {
  const api = useApi()
  const surfaces: Ref<SurfaceCollectionCategoryWithCollections> = ref({})

  function getSurface(id: number) {
    if (!surfaces.value) return

    return Object.values(surfaces.value)
      .map((category) => {
        return category.surfaceCollections
          .map((collection) => collection.surfaces)
          .flat()
      })
      .flat()
      .find((surface) => surface.nid === id)
  }

  function getSurfaceCategory(id: number) {
    let category = 116

    Object.values(surfaces.value)
      .map((category) => {
        return {
          categoryId: category.nid,
          surfaces: category.surfaceCollections
            .map((collection) => collection.surfaces)
            .flat(),
        }
      })
      .forEach((surfacesWithCategory) => {
        surfacesWithCategory.surfaces.forEach((surface) => {
          if (surface.nid === id) {
            category = surfacesWithCategory.categoryId ?? 116
          }
        })
      })

    return category
  }

  let initPromise: Promise<SurfaceCollectionCategoryWithCollections>
  async function init() {
    if (initPromise) {
      return initPromise
    }
    initPromise = new Promise<SurfaceCollectionCategoryWithCollections>(
      async (resolve) => {
        api.getSurfaces().then((res) => {
          surfaces.value = res
          resolve(surfaces.value)
        })
      }
    )
    return initPromise
  }

  return {
    surfaces,
    init,
    getSurface,
    getSurfaceCategory,
  }
})
